import React, { useState } from 'react';
import { useAppDispatch } from 'hooks';
import { Button } from 'reactstrap';

import { validateUserMobile } from '~care-workers/lib/validate';

import FormField from '~components/form-fields/Field';
import FormInputMobile from '~care-workers/components/FormInputMobile';

import { sendDetails } from '~care-workers/actions/userLoginDetails';

interface ComponentProps {
  id: string;
  email?: string;
  mobile?: string;
}
interface Notification {
  type: 'email' | 'sms';
  detail?: string;
}

export const SendDetailsModal: React.FC<ComponentProps> = ({ id, email, mobile }) => {
  const dispatch = useAppDispatch();
  const [details, setDetails] = useState({ email, mobile });
  const [sending, setSending] = useState(false);

  const send = async ({ detail, type }: Notification) => {
    setSending(true);
    await dispatch(sendDetails({ type, detail, id }));
    setSending(false);
  };

  return (
    <div className="send-details-modal">
      <div className="send-details-modal-container">
        <div className="send-details-modal-field">
          <FormField
            id="email"
            caption="Email"
            value={details.email}
            fieldId="email"
            placeholder="Email"
            dataCy="send_login"
            handleChange={(_, value) => {
              setDetails((old) => ({ ...old, email: value }));
            }}
          />
        </div>
        <Button disabled={sending} onClick={() => send({ type: 'email', detail: details.email })} className="me-2 w-25">
          Send To Email
        </Button>
      </div>
      <div className="send-details-modal-container">
        <div className="send-details-modal-field">
          <FormField
            id="email"
            value={details.mobile}
            caption="Mobile"
            placeholder="Mobile Number"
            fieldId="mobile"
            component={FormInputMobile}
            validateOnSave={validateUserMobile}
            dataCy="send_login"
            type="custom"
            handleChange={(_, value) => {
              setDetails((old) => ({ ...old, mobile: value }));
            }}
          />
        </div>
        <Button disabled={sending} onClick={() => send({ type: 'sms', detail: details.mobile })} className="me-2 w-25">
          SMS Details
        </Button>
      </div>
    </div>
  );
};

export default SendDetailsModal;
